import React, { useMemo, useEffect } from "react";
import "../../scss/dashboard/plantillasVendidas.css";
import { ProgressBar } from "react-step-progress-bar";
import DashGraph from "./DashGraph";
import { usePublicTemplateList } from "../../api/hooks/public-templates";
import RH from "../../images/dashboardAbogados/RH.svg";
import Arrendamiento from "../../images/dashboardAbogados/Arrendamiento.svg";
import Comerciales from "../../images/dashboardAbogados/Comerciales.svg";
import { getPrice, parseDate } from "../../utils";
import { Table } from "./Table";
import { Spinner } from "reactstrap";

import NoFoldersScreen from "./Publicadas/noFoldersScreen";
function PlantillasVendidas() {
  const { data, isLoading } = usePublicTemplateList({
    enabled: true,
    onlyMyTemplates: true,
  });

  const [topSold, setTopSold] = React.useState([]);
  const [topSoldIndex, setTopSoldIndex] = React.useState([]);
  const getTopSold = (data) => {
    let newObject = data
      ?.filter((x) => x.sold !== undefined)
      .sort((a, b) => b.sold - a.sold)
      .slice(0, 3);
    setTopSold(newObject);
  };
  // const getTopSoldIndex = (data) => {
  //   let newObject = data
  //     ?.filter((x) => x.sold !== undefined)
  //     .sort((a, b) => b.sold - a.sold)
  //     .slice(0, 2);
  //   setTopSoldIndex(newObject);
  // };
  useEffect(() => {
    getTopSold(data?.data);
    // getTopSoldIndex(data?.data);
    console.log(data);
  }, [data]);
  useEffect(() => {
    console.log(topSold);
  }, [topSold]);
  const cols = useMemo(
    () => [
      {
        label: "ID",
        className: "table__id",
        render: (publicTemplate, i) => i + 1,
      },
      {
        label: "NOMBRE DE PLANTILLA",
        className: "table__name",
        key: "name",
      },
      {
        label: "VISTAS",
        className: "",
        render: (publicTemplate) => (
          <div className="table__status table__status--progress mostSells__views">
            <p>{publicTemplate.views || 0}</p>
          </div>
        ),
      },
      {
        label: "PRECIO",
        className: "",
        render: (publicTemplate) => (
          <div className="table__price mostSells__price">
            <p>
              {getPrice(
                publicTemplate?.stripeInfo?.price,
                publicTemplate?.stripeInfo?.currency
              )}
            </p>
          </div>
        ),
      },
      {
        label: "VENTAS",
        className: "table__sells mostSells__sells",
        key: "sold",
      },
      {
        label: "FECHA DE CREACIÓN",
        className: "table__date mostSells__date",
        render: (publicTemplate) => parseDate(publicTemplate.createdAt),
      },
      // {
      //   label: 'PERFORMANCE',
      //   className: 'position-relative',
      //   render: (publicTemplate) =>
      //     <div
      //       style={{
      //         position: "absolute",
      //         top: "-7px",
      //         left: "-50px",
      //       }}
      //     >
      //         <DashGraph />
      //     </div>
      // },
    ],
    []
  );

  console.log({ cols });

  return (
    <React.Fragment>
      {topSold?.length > 0 ? (
        <section className="plantillasVendidas">
          <div className="plantillasVendidas__mostsellso--one">
            <div className="saldo__texto">
              <h3 className="font-weight-bold">Plantillas Vendidas</h3>
            </div>
            <div className="plantillasMasVendidas__container">
              {topSold?.length >= 0 && !isLoading ? (
                topSold?.map((item) => (
                  <CategorySummary
                    icon={RH}
                    width={215}
                    label={item.name}
                    income={(item?.stripeInfo?.price / 100) * item.sold}
                    sold={item.sold}
                  />
                ))
              ) : (
                <Spinner
                  style={{
                    margin: "0px auto",
                    marginTop: "30%",
                    "grid-column-start": "2",
                  }}
                />
              )}
            </div>
          </div>
          <div>
            <PublicTemplateTable cols={cols} sortBy="sold" />
          </div>
        </section>
      ) : (
        <div>
          <div className="saldo__texto" style={{ marginBottom: "20px" }}>
            <h3 className="font-weight-bold">Plantillas Vendidas</h3>
          </div>

          <NoFoldersScreen text={"Sin plantillas para mostrar"} width={"80%"} />
        </div>
      )}
    </React.Fragment>
  );
}

export default PlantillasVendidas;

function PublicTemplateTable({ cols, sortBy }) {
  const { data, isLoading } = usePublicTemplateList({
    enabled: !!cols.length,
    onlyMyTemplates: true,
    sortBy,
  });

  return (
    <Table isLoading={isLoading} items={data?.data} cols={cols} width={84} />
  );
}

function CategorySummary({ icon, label, income, sold, percent = 0, width }) {
  return (
    <div
      className="inicio__box alt-inicio__box--mostSells MostSell___div"
      style={{ width: `${width}px` }}
    >
      <img src={icon} alt="svg" className="mostsellSVG" />
      <div></div>
      <div className="alt-inicio__box--mostSells--name">
        <h4 className="font-weight-bold">{label}</h4>
      </div>
      <div className="alt-inicio__box--mostSells--income">
        <p className="mostSells--income-p">
          <span className="mostSells--income-span1">Ingresos</span> <br />
          <span className="mostSells--income-span2">${income || 0}</span>
        </p>
        <p className="mostSells--income-p2">
          {sold} {sold === 1 ? "venta" : "ventas"}
        </p>
      </div>
      {/* <div>
        <ProgressBar
          percent={percent}
          filledBackground="#f37b33"
          unfilledBackground="#eaeaea"
          width={"100%"}
        />
      </div> */}
    </div>
  );
}
export function IndexTopSold() {
  const { data, isLoading } = usePublicTemplateList({
    enabled: true,
    onlyMyTemplates: true,
  });

  const [topSoldIndex, setTopSoldIndex] = React.useState([]);

  const getTopSoldIndex = (data) => {
    let newObject = data
      ?.filter((x) => x.sold !== undefined)
      .sort((a, b) => b.sold - a.sold)
      .slice(0, 2);
    setTopSoldIndex(newObject);
  };
  useEffect(() => {
    getTopSoldIndex(data?.data);
    console.log(data);
  }, [data]);
  return (
    <React.Fragment>
      <div
        style={{ width: "auto", height: "auto", display: "flex", gap: "30px" }}
      >
        {topSoldIndex && !isLoading ? (
          topSoldIndex?.map((item) => (
            <CategorySummary
              icon={RH}
              label={item.name}
              income={(item?.stripeInfo?.price / 100) * item.sold}
              sold={item.sold}
              width={210}
            />
          ))
        ) : (
          <Spinner
            style={{
              margin: "0px auto",
              marginTop: "15%",
            }}
          />
        )}
      </div>
    </React.Fragment>
  );
}
